
import { Component, Vue } from "vue-property-decorator";
import { MarketStore } from "@/store/modules";
import { eventHub } from "@/utils/eventHub";
import { Base, getApi } from "@/store/api/api";
import { Action } from "@/store/actionType";
import ContentHeader from "@/components/UIComponents/ContentHeader.vue";
import { Product, ProductPrice } from "@/store/model/market";

import date from 'quasar/src/utils/date.js';;

import { BSToAD } from "bikram-sambat-js";

import NepaliDatePicker from "@/components/UIComponents/DatePicker/NepaliDatePicker.vue";

import exportFile from 'quasar/src/utils/export-file.js';;
import { nepaliUnicodeNumber } from "@/utils/date";
import { QTablePagination } from "@/store/model/page";

@Component({
  components: { ContentHeader, NepaliDatePicker },

  //   metaInfo(): MetaInfo {
  //     return {
  //       titleTemplate: 'Marketplace Home',
  //       meta: [
  //         { charset: "utf-8" },
  //         { name: "viewport", content: "width=device-width, initial-scale=1" }
  //       ]
  //     };
  //   }
})
export default class PriceReports extends Vue {
  headerBackgroundUrl = "about.jpg";
  price_id = 0;
  timeStamp = new Date().toJSON();
  // currentDate = date.formatDate(this.timeStamp, "DD-MM-YYYY HH:mm:ss");
  async created() {
    const route_params = this.$route.params;
    if (route_params.id) {
      this.price_id = Number(route_params.id);
    }
    await MarketStore.getProductList();
    await MarketStore.getMarketsList();
    await MarketStore.getProductPricebyId({
      id: this.price_id,
      market_id: MarketStore.MARKETPLACE_ID,
    });
    this.product;
    this.markets;
    this.productPricebyId;
  }

  onSubmit = async () => {
    await this.editProductPrice(Number(this.$route.params.id));
  };

  get productPricebyId() {
    const res = MarketStore.ProductPrice;
    return res;
  }

  set productPricebyId(value: ProductPrice) {
    MarketStore.ProductPrice = value;
  }

  get product() {
    const res = MarketStore.ProductList;
    return res;
  }
  get markets() {
    const res = MarketStore.MarketList;
    return res;
  }

  async editProductPrice(id: number) {
    this.productPricebyId.local_modified_on = this.timeStamp;
    this.productPricebyId.wholesale_avg = String(
      (Number(this.productPricebyId.wholesale_min) +
        Number(this.productPricebyId.wholesale_max)) /
        2
    );
    delete this.productPricebyId.local_created_on;
    await MarketStore.editProductPrice({
      data: this.productPricebyId,
      id: id,
      market_id: MarketStore.MARKETPLACE_ID,
    })
      .then(() => {
        this.$q.notify({
          type: "positive",
          message: `Successfully Edited.`,
        });
        this.$router.push({
          name: "PriceList",
        });
      })
      .catch(() => {
        this.$q.notify("An error occurred while performing this action.");
      });
  }
}
